import { render } from "./Accomplishments.vue?vue&type=template&id=1746c95a&scoped=true"
import script from "./Accomplishments.vue?vue&type=script&lang=js"
export * from "./Accomplishments.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1746c95a"

export default script